/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/* 
Atmosphere blocks
*/
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedStatements } from '../block_compatibility_checks';

Blockly.Blocks['input_atmospheric_data_only'] = {
    init: function () {
        this.appendDummyInput()
            .appendField('Atmospheric data: ')
            .appendField(new Blockly.FieldDropdown([
                ['TOMS and OMI Merged Ozone Data', 'ozone']
            ]), "dropdown")
        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('other_data_only'))
        this.setInputsInline(false);
        this.setStyle('input')
        this.setTooltip(Blockly.Msg.ATMOSPHERIC_DATA_BLOCK_TOOLTIP);
        this.setHelpUrl("");
    },
};